import { getFunctions } from "firebase/functions";

const useFunctionsService = () => ({ functions: getFunctions() });

export default useFunctionsService;
